import bannerImage from '@/assets/img/commission-banner-modal.png';
import CustomModal from '@/shared/components/CustomModal';

interface CommissionUpdateBannerModalProps {
  isOpen: boolean;
  onClose: () => void;
}

function CommissionUpdateBannerModal({ isOpen, onClose }: CommissionUpdateBannerModalProps) {
  return (
    <CustomModal
      isOpen={isOpen}
      onClose={onClose}
      closeOnBlur
      className="w-full max-w-xl"
      childrenClassName="overflow-visible max-h-[80vh]"
    >
      <div className="flex flex-col gap-3xl">
        <img
          src={bannerImage}
          alt="افزایش کمیسیون‌های جدید دیجی‌کالا در سال ۱۴۰۵"
          className="w-full rounded-md"
        />
        <div className="space-y-md sm:text-md text-sm font-medium leading-relaxed text-text-secondary-700">
          <p>ناشران گرامی سلام</p>
          <p>
            مدل کمیسیونی افیلیو در سال ۱۴۰۵ به‌روزرسانی می‌شود و این تغییرات از ۱ مرداد در تمامی
            سطوح برای شما فعال خواهد شد.
          </p>
          <p>با تشکر از همراهی شما</p>
        </div>
      </div>
    </CustomModal>
  );
}

export default CommissionUpdateBannerModal;
